import { Field, FieldProps } from 'formik';
import { FormField } from '../FormField';
import { IbanInput } from '../IbanInput';

interface FormikIbanInputProps {
  name: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * Champ IBAN branché sur Formik : l'affichage est groupé par 4, la valeur
 * conservée dans le formulaire est normalisée (majuscules, sans espaces).
 */
export const FormikIbanInput: React.FC<FormikIbanInputProps> = ({
  name,
  label,
  required,
  placeholder,
  disabled
}) => (
  <Field name={name}>
    {({ field, meta, form }: FieldProps) => (
      <FormField
        label={label}
        error={meta.touched && meta.error ? meta.error : undefined}
        required={required}
        name={name}
      >
        <IbanInput
          name={name}
          value={field.value ?? ''}
          onChange={v => form.setFieldValue(name, v)}
          onBlur={() => form.setFieldTouched(name, true)}
          placeholder={placeholder}
          disabled={disabled}
        />
      </FormField>
    )}
  </Field>
);
